import { render, staticRenderFns } from "./DeleteHostModal.vue?vue&type=template&id=70bcf29c&"
import script from "./DeleteHostModal.vue?vue&type=script&lang=js&"
export * from "./DeleteHostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bcf29c')) {
      api.createRecord('70bcf29c', component.options)
    } else {
      api.reload('70bcf29c', component.options)
    }
    module.hot.accept("./DeleteHostModal.vue?vue&type=template&id=70bcf29c&", function () {
      api.rerender('70bcf29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Mysql/Remote/DeleteHostModal.vue"
export default component.exports